import React from 'react'
import cx from 'classnames'
import { TimeoutButton } from '@local/do-secundo-timeout-button'

export interface SmsConfirmationProps {
  testId?: string
  title?: React.ReactNode
  icon?: React.ReactNode
  mainText?: React.ReactNode
  phone?: React.ReactNode
  secondaryText?: React.ReactNode
  form: React.ReactNode
  handleResend?: (e?: React.MouseEvent<HTMLElement>) => void
  footer?: React.ReactNode
  smsConfirmationClassName?: string
}

export const SmsConfirmation = ({
  testId = 'sms-confirmation',
  icon = null,
  title = null,
  mainText,
  phone,
  secondaryText,
  form,
  handleResend,
  footer,
  smsConfirmationClassName
}: SmsConfirmationProps) => {
  return (
    <div
      data-testid={testId}
      className={cx(
        'flex flex-col justify-center items-center text-center text-xl text-oo-primary',
        smsConfirmationClassName
      )}
    >
      {icon}
      {title}
      {mainText && (
        <div className='type-default text-oo-black-87'>{mainText}</div>
      )}
      {phone && <div className='py-2 font-bold text-oo-black-87'>{phone}</div>}
      {secondaryText && (
        <div className='type-default text-oo-black-87'>{secondaryText}</div>
      )}
      <div>{form}</div>
      {handleResend && (
        <div className='p-4 '>
          <p className='mb-4 type-default text-oo-grey'>Didn't receive a code?</p>
          <TimeoutButton
            onClick={handleResend}
            timeoutPeriod={5000}
            maxNumberOfRetries={5}
            data-testid={`${testId}-resend-code-button`}
          >
            Resend code
          </TimeoutButton>
        </div>
      )}
      {footer}
    </div>
  )
}
